export default __webpack_public_path__ + "static/media/Roboto-Italic.8c7189a7.ttf";